module.exports = __webpack_public_path__ + "../resources/img/ic_hide_default.06d78508.svg";